// API ünvanı .env-dən idarə olunur:
//   .env.development  → REACT_APP_API_URL=http://127.0.0.1:8000/api/v1/
//   .env.production   → REACT_APP_API_URL=https://afiktahirov.site/api/v1/
export const BASE_URL =
  process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/v1/";
